import React from 'react'
import ReactDOM from 'react-dom'
import {connect} from "react-redux"
import PropTypes from 'prop-types'

import NestedList from '../Lists/NestedList.js'
import StackedList from '../Lists/StackedList.js'

import { modalWrap } from '../../SearchAir.js'

import { 
  selectIsModalActive,
  selectActiveModal,
  selectModalContextIds,
  selectContexts,
  selectContextById,
  selectSorts, 
  STACKED_LIST_CONTROLLER,
  NESTED_LIST_CONTROLLER
} from '../../State/selectors.js'

import { 
  openModal,
  closeModal,
  changeSort,
  deactivateFilterContext,
  closeModalAndFetchResults
} from '../../State/actions.js'

const mapStateToProps = (state) => {
  var isModalActive = selectIsModalActive(state)
  var activeModal = selectActiveModal(state)
  var contextIds = selectModalContextIds(state)
  var contexts = selectContexts(state)
  var activeContext = selectContextById(state, activeModal)
  var sorts = selectSorts(state)

  return { 
    isModalActive, 
    activeModal,
    contextIds,
    contexts,
    activeContext,
    sorts
  }
}

const actions = {
  openModal,
  closeModal,
  changeSort,
  deactivateFilterContext,
  closeModalAndFetchResults
}

class Modal extends React.Component {
  static get propTypes () {
    return {
      isModalActive: PropTypes.bool,
      activeModal: PropTypes.string,
      contexts: PropTypes.object,
      contextIds: PropTypes.array, 
      openModal: PropTypes.func,
      closeModal: PropTypes.func,
      activeContext: PropTypes.object,
      sorts: PropTypes.array,
      changeSort: PropTypes.func,
      deactivateFilterContext: PropTypes.func,
      closeModalAndFetchResults: PropTypes.func
    }
  }
  
  renderModalTabs () {
    var { contexts, contextIds, activeModal, openModal } = this.props

    var tabs = contextIds.map((contextId) => {
      var classes = [
        "switch-modal fdn-search-modal-tab",
        activeModal === contextId ? "uk-active" : null
      ]
      return (
        <li key={contextId} 
          className={classes.filter(v => v).join(" ")}
          onClick={() => openModal(contextId)}>
          <a>
            { contexts[contextId].title }
          </a>
        </li>
      )
    })

    return (
      <ul data-uk-tab className="uk-margin-remove fdn-search-modal-tabs">
        {tabs}
      </ul>
    )
  }

  renderModalContent () {
    var { activeModal, contexts } = this.props
    const currentContext = contexts[activeModal]

    if (currentContext.type === STACKED_LIST_CONTROLLER) {
      return <StackedList />
    }
    if (currentContext.type === NESTED_LIST_CONTROLLER) {
      return <NestedList />
    }
  }

  renderSortModal () {
    var { 
      isModalActive, sorts, 
      changeSort, closeModalAndFetchResults 
    } = this.props

    return (
      <div style={ isModalActive ? { display: "block" } : null }
        className="uk-modal uk-open">

        {/* Dimmer Shim */}
        <div className="uk-position-absolute uk-position-cover" 
          onClick={closeModalAndFetchResults}></div>

        <div className="uk-modal-dialog fdn-search-modal fdn-search-sort-modal"
          style={{width:"560px"}}>


          <div className="uk-modal-header fdn-search-modal-header uk-position-relative">
            <h4 className="uk-padding-small uk-margin-remove">
              Sort By
            </h4> 
            <a data-uk-close 
              className="uk-position-center-right uk-padding-small" 
              onClick={closeModalAndFetchResults}>
            </a>
          </div>

          <div className="uk-modal-body uk-margin-remove uk-padding-remove">
            <ul className="uk-list uk-list-divider uk-margin-remove uk-padding-remove">

              { sorts.map( sort => {
                return (

                  <li key={sort.value}
                    className="fdn-search-sort-item uk-margin-remove"
                    onClick={() => changeSort(sort.value) }>
                    {sort.name}
                  </li>
                )
              })}
            </ul>
          </div>

        </div>
      </div>
    )
  }

  renderModal () {
    var { 
      isModalActive, activeModal,  
      deactivateFilterContext, closeModalAndFetchResults 
    } = this.props
    
    if ( !isModalActive ) {
      return null
    }

    return (
      <div style={ isModalActive ? { display: "block" } : null } 
        className="uk-modal uk-open">

        {/* Dimmer Shim */}
        <div className="uk-position-absolute uk-position-cover" 
          onClick={closeModalAndFetchResults}></div>

        <div className="uk-modal-dialog fdn-search-modal"
          style={{width:"720px"}}>

          <div className="uk-modal-header fdn-search-modal-header
            uk-position-relative">
            { this.renderModalTabs() }
            <a data-uk-close 
              className="uk-position-center-right uk-padding-small" 
              onClick={closeModalAndFetchResults}>
            </a>
          </div>

          <div data-uk-overflow-auto 
            className="uk-modal-body fdn-search-modal-body">
            { this.renderModalContent() } 
          </div>

          <div className="uk-modal-footer fdn-search-modal-footer
            uk-flex uk-flex-between">
            <a className="fdn-button-submit"
              onClick={() => deactivateFilterContext(activeModal)}>
              clear
            </a>
            <a className="fdn-button-control"
              onClick={() => closeModalAndFetchResults()}>
              done
            </a>
          </div>

        </div>
      </div>
    )
  }

  render () {
    var { activeModal } = this.props
    return ReactDOM.createPortal(
      activeModal === "sort" ? this.renderSortModal() : this.renderModal(),
      modalWrap
    );
  }
}

export default connect(mapStateToProps, actions)(Modal);
